import * as jsxRuntime from "/Applications/XAMPP/xamppfiles/htdocs/WorkSpace/imageEditor/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment